export const COUNTRIES = [
  { description: 'Afghanistan', value: 'AF' },
  { description: 'Albania', value: 'AL' },
  { description: 'Algeria', value: 'DZ' },
  { description: 'Armenia', value: 'AM' },
  { description: 'Austria', value: 'AT' },
  { description: 'Azerbaijan', value: 'AZ' },
  { description: 'Bangladesh', value: 'BD' },
  { description: 'Belarus', value: 'BY' },
  { description: 'Belgium', value: 'BE' },
  { description: 'Brazil', value: 'BR' },
  { description: 'Bulgaria', value: 'BG' },
  { description: 'Canada', value: 'CA' },
  { description: 'China', value: 'CN' },
  { description: 'Croatia', value: 'HR' },
  { description: 'Czech Republic', value: 'CZ' },
  { description: 'Denmark', value: 'DK' },
  { description: 'Egypt', value: 'EG' },
  { description: 'Estonia', value: 'EE' },
  { description: 'Ethiopia', value: 'ET' },
  { description: 'Finland', value: 'FI' },
  { description: 'France', value: 'FR' },
  { description: 'Georgia', value: 'GE' },
  { description: 'Germany', value: 'DE' },
  { description: 'Greece', value: 'GR' },
  { description: 'Hungary', value: 'HU' },
  { description: 'Iceland', value: 'IS' },
  { description: 'India', value: 'IN' },
  { description: 'Indonesia', value: 'ID' },
  { description: 'Iran', value: 'IR' },
  { description: 'Ireland', value: 'IE' },
  { description: 'Israel', value: 'IL' },
  { description: 'Italy', value: 'IT' },
  { description: 'Japan', value: 'JP' },
  { description: 'Kazakhstan', value: 'KZ' },
  { description: 'Kenya', value: 'KE' },
  { description: 'South Korea', value: 'KR' },
  { description: 'Latvia', value: 'LV' },
  { description: 'Lithuania', value: 'LT' },
  { description: 'Malaysia', value: 'MY' },
  { description: 'Malta', value: 'MT' },
  { description: 'Mexico', value: 'MX' },
  { description: 'Mongolia', value: 'MN' },
  { description: 'Morocco', value: 'MA' },
  { description: 'Nepal', value: 'NP' },
  { description: 'Netherlands', value: 'NL' },
  { description: 'New Zealand', value: 'NZ' },
  { description: 'Nigeria', value: 'NG' },
  { description: 'Norway', value: 'NO' },
  { description: 'Pakistan', value: 'PK' },
  { description: 'Peru', value: 'PE' },
  { description: 'Philippines', value: 'PH' },
  { description: 'Poland', value: 'PL' },
  { description: 'Portugal', value: 'PT' },
  { description: 'Romania', value: 'RO' },
  { description: 'Russia', value: 'RU' },
  { description: 'Saudi Arabia', value: 'SA' },
  { description: 'Serbia', value: 'RS' },
  { description: 'Singapore', value: 'SG' },
  { description: 'Slovakia', value: 'SK' },
  { description: 'Slovenia', value: 'SI' },
  { description: 'South Africa', value: 'ZA' },
  { description: 'Spain', value: 'ES' },
  { description: 'Sri Lanka', value: 'LK' },
  { description: 'Sweden', value: 'SE' },
  { description: 'Switzerland', value: 'CH' },
  { description: 'Syria', value: 'SY' },
  { description: 'Taiwan', value: 'TW' },
  { description: 'Tajikistan', value: 'TJ' },
  { description: 'Tanzania', value: 'TZ' },
  { description: 'Thailand', value: 'TH' },
  { description: 'Tunisia', value: 'TN' },
  { description: 'Turkey', value: 'TR' },
  { description: 'Uganda', value: 'UG' },
  { description: 'Ukraine', value: 'UA' },
  { description: 'United Arab Emirates', value: 'AE' },
  { description: 'United Kingdom', value: 'GB' },
  { description: 'United States', value: 'US' },
  { description: 'Uzbekistan', value: 'UZ' },
  { description: 'Venezuela', value: 'VE' },
  { description: 'Vietnam', value: 'VN' },
  { description: 'Yemen', value: 'YE' },
  { description: 'Zimbabwe', value: 'ZW' },
];
